import React, { useEffect, useState } from "react";
import DashboardLayout from "../../../../Layout/DashboardLayout";
import { useParams } from "react-router-dom";
import axios from "axios";
import { errorToast } from "../../../../Components/ToastMessage";
import moment from "moment";

const InterviewDetails = () => {
  const { id } = useParams();
  const [interviewDetails, setInterviewDetails] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const response = await axios.get(`/interviews/data/${id}`);
        if (response.data) {
          const responseData = response.data;
          const aiReport = JSON.parse(
            responseData?.interviewData?.aiReport ?? "{}"
          );
          const candidateObject = {
            aiReport: aiReport?.report,
            candidate: responseData.candidate.name,
            position: responseData.position.name,
            interviewer: responseData.interviewer.name,
            date: responseData.date,
            time: responseData.time,
            transcript: aiReport?.jsonArray,
            attachments: JSON.parse(
              responseData?.interviewData?.devices ?? "{}"
            ),
          };
          console.log("====================================");
          console.log(candidateObject);
          console.log("====================================");
          setInterviewDetails(candidateObject);
          // console.log(response.data);
        }
      } catch (error) {
        errorToast(error.message);
      }
    })();
  }, [id]);

  const aiReportSummary = `Out of ${
    interviewDetails?.aiReport?.totalQuestions
  } questions, 
  ${
    interviewDetails?.aiReport?.totalAIGeneratedAnswers
  } answers were detected as AI-generated, 
  and ${
    interviewDetails?.aiReport?.totalQuestions -
    interviewDetails?.aiReport?.totalAIGeneratedAnswers
  } answers were given by the candidate. Almost ${
    interviewDetails?.aiReport?.percentAIGenerated
  }% of answers are AI Generated`;

  return (
    <DashboardLayout>
      {interviewDetails ? (
        <div className="bg-gray-100 h-full overflow-y-auto p-6">
          <h1 className="text-3xl font-bold text-gray-800 mb-6">
            Interview Details
          </h1>

          <div className="bg-white shadow-md rounded-lg p-6 mb-6">
            <h2 className="text-2xl font-semibold text-gray-700 mb-4">
              {interviewDetails?.candidate}
            </h2>
            <p className="text-gray-600">
              <strong>Position:</strong> {interviewDetails?.position}
            </p>
            <p className="text-gray-600">
              <strong>Date:</strong>{" "}
              {moment.utc(interviewDetails?.date).format("YYYY-MM-DD")}{" "}
              {moment
                .utc(
                  `${interviewDetails?.date?.split("T")[0]}T${
                    interviewDetails?.time
                  }:00+00:00`
                )
                .format("hh:mm a")}
            </p>
            <p className="text-gray-600">
              <strong>Interviewer:</strong> {interviewDetails?.interviewer}
            </p>
          </div>

          <div className="bg-white shadow-md rounded-lg p-6 mb-6">
            <h3 className="text-xl font-semibold text-gray-700 mb-4">
              AI-Generated Report
            </h3>
            <p className="text-gray-600">{aiReportSummary}</p>
          </div>

          <div className="bg-white shadow-md rounded-lg p-6 mb-6">
            <h3 className="text-xl font-semibold text-gray-700 mb-4">
              Interview Transcript
            </h3>
            {interviewDetails?.transcript?.map((item, index) => (
              <div key={index} className="mb-4">
                {item.type === "sent" ? (
                  <p className="text-gray-800 font-semibold inline-flex">
                    Q:{" "}
                    <div dangerouslySetInnerHTML={{ __html: item.message }} />
                  </p>
                ) : (
                  <p className="text-gray-600 mt-2 inline-flex">
                    <strong>A:</strong>{" "}
                    <div dangerouslySetInnerHTML={{ __html: item.message }} />
                  </p>
                )}
              </div>
            ))}
          </div>

          <div className="bg-white shadow-md rounded-lg p-6">
            <h3 className="text-xl font-semibold text-gray-700 mb-4">
              Attached Devices
            </h3>
            <h5 className="text-md font-semibold text-gray-700 mb-4">
              Media Devices
            </h5>
            <ul className="list-disc pl-5 text-gray-600">
              {interviewDetails?.attachments?.mediaDevices?.map(
                (attachment, index) => (
                  <li key={index} className="mb-2">
                    <strong>{attachment?.label}:</strong> {attachment?.kind}
                  </li>
                )
              )}
            </ul>
            <h5 className="text-md font-semibold text-gray-700 mb-4">
              Bluetooth Devices
            </h5>
            <ul className="list-disc pl-5 text-gray-600">
              {interviewDetails?.attachments?.bluetoothDevice ? (
                interviewDetails?.attachments?.bluetoothDevice?.map(
                  (attachment, index) => (
                    <li key={index} className="mb-2">
                      <strong>{attachment?.label}:</strong> {attachment?.kind}
                    </li>
                  )
                )
              ) : (
                <li className="mb-2">No Bluetooth Devices</li>
              )}
            </ul>
            <h5 className="text-md font-semibold text-gray-700 mb-4">
              USB Devices
            </h5>
            <ul className="list-disc pl-5 text-gray-600">
              {interviewDetails?.attachments?.usbDevice ? (
                interviewDetails?.attachments?.usbDevice?.map(
                  (attachment, index) => (
                    <li key={index} className="mb-2">
                      <strong>{attachment?.label}:</strong> {attachment?.kind}
                    </li>
                  )
                )
              ) : (
                <li className="mb-2">No USB Devices</li>
              )}
            </ul>
          </div>
        </div>
      ) : (
        <>Loading...</>
      )}
    </DashboardLayout>
  );
};

export default InterviewDetails;
